import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { OpenMailIcon } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

export const MessageCenterDetailsEmpty: FC = () => {
  const { t } = useTranslate();
  return (
    <Stack direction="column" gap={4} flexGrow={1} justifyContent="center" alignItems="center">
      <OpenMailIcon />
      <Typography fontSize="1.125rem" fontWeight={700}>
        {t('messageCenter.selectAMessageYouWantToViewOrCreateA')}
      </Typography>
    </Stack>
  );
};
